import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import {
  Box,
  List,
  Avatar,
  ListItem,
  Typography,
  ListItemText,
  ListItemAvatar,
} from '@material-ui/core';
import moment from 'moment';
import useStyles from './Comments.styled';
import Paginator from 'components/Paginator';

const CommentsList = ({
  params,
  comments,
  pagination,
  handleChangePage,
  handleChangeRowsPerPage,
}) => {
  const classes = useStyles();
  const { localeFormat } = useSelector((state) => state.organizations);

  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="space-between"
      className={classes.listBox}
    >
      <List className={classes.listRoot}>
        {comments?.map((comment, index) => {
          return (
            <ListItem key={index} alignItems="flex-start" className={classes.listItem}>
              <ListItemAvatar className={classes.avatarWrapper}>
                <Avatar alt="User" className={classes.avatar}>
                  {comment?.entry_user?.first_name?.charAt(0)}
                  {comment?.entry_user?.last_name?.charAt(0)}
                </Avatar>
              </ListItemAvatar>
              <ListItemText
                primary={
                  <Box display="flex" alignItems="center" justifyContent="space-between">
                    <Typography
                      variant="body2"
                      component="span"
                      color="textPrimary"
                      className={classes.name}
                    >
                      {comment?.entry_user?.first_name} {comment?.entry_user?.last_name}
                    </Typography>
                    <Typography
                      variant="body2"
                      component="span"
                      color="textSecondary"
                      className={classes.date}
                    >
                      {moment(comment.created_time).format(`${localeFormat} - hh:mm a`)}
                    </Typography>
                  </Box>
                }
                secondary={
                  <>
                    <Typography component="span" color="textSecondary" className={classes.comment}>
                      {comment?.body}
                    </Typography>
                  </>
                }
              />
            </ListItem>
          );
        })}
      </List>
      <Paginator
        component="div"
        limit={params.limit}
        onPageChange={handleChangePage}
        pagination={pagination}
        labelRowsPerPage="Page size"
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </Box>
  );
};

CommentsList.propTypes = {
  params: PropTypes.object,
  comments: PropTypes.array,
  pagination: PropTypes.object,
  handleChangePage: PropTypes.func,
  handleChangeRowsPerPage: PropTypes.func,
};

CommentsList.defaultProps = {
  params: {
    page: 1,
    limit: 10,
  },
  comments: [],
  pagination: {},
  handleChangePage: () => {},
  handleChangeRowsPerPage: () => {},
};

export default CommentsList;
